// =============================================================================
// CreateDelegationPage — redirect shell for /approvals/delegations/new
// The create delegation flow is implemented as a dialog launched from
// MyDelegationsPage (FE-08). This page redirects there with ?create=true so
// the dialog opens automatically, providing a seamless direct-URL entry point.
// =============================================================================

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DelegationPageSkeleton } from '../components/DelegationSkeletons';

export const CreateDelegationPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect immediately — replace history entry so Back doesn't loop
    navigate('/approvals/delegations?create=true', { replace: true });
  }, [navigate]);

  // Show a brief skeleton while the redirect executes
  return <DelegationPageSkeleton />;
};
